import React from "react";
import { useParams } from "react-router-dom";

function Target() {
    const tokenParam = useParams();
    const what = (tokenParam as {what: string}).what?.replace(/:/, "");
    return (
        <div>
            <h1>target</h1>
            {what.length}
        </div>
    );
}
export default (Target);